// src/app/cozucuOncesiRotalar.ts
//
// ÇÖZÜCÜDEN ÖNCE ELE ALINAN ROTALAR — TEK KAYNAK.
//
// ── NEDEN VAR ────────────────────────────────────────────────────────────────
// Üç yol `resolvePathToPage`e HİÇ ULAŞMAZ: `App.tsx` onları render gövdesinde
// erken `return` ile karşılar (oturumsuz açılabilmeleri gerekiyor —
// e-posta doğrulama linki, kart şablonu, yasal sayfalar):
//
//     /auth/action                       → <AuthActionHandler />
//     /card/{kod}                        → <CardTemplatePage />
//     /{yasal-slug}                      → <LegalPage />
//
// Çözücü bu yollar için `false` döner ve bu DOĞRUDUR: ekranı zaten başkası
// veriyor. Ama "çözücü false döndü" ile "bu adres hiçbir yere gitmiyor" ayırt
// edilemediği sürece, ölü rota kapısı (`oluRotaMi`) bu üç meşru yolun üstüne
// «Sayfa bulunamadı» kartı basardı.
//
// ── NEDEN İKİNCİ BİR LİSTE DEĞİL ─────────────────────────────────────────────
// Desenler eskiden YALNIZ `App.tsx` gövdesinde satır-içi regex olarak vardı.
// Kapı onları ikinci kez yazsaydı, bu deponun kayıtlı «çürüyen liste» sınıfının
// yeni bir üyesi olurdu: yasal bir slug eklenir, kopya güncellenmez, ve o sayfa
// bir gün sessizce «Sayfa bulunamadı» gösterirdi. Bu yüzden desenler BURADA
// yaşar; `App.tsx` de kapı da BURAYI okur. Tek şema, iki tüketici.

/** E-posta doğrulama linkinin (mail istemcisinden gelen) yolu. */
export const AUTH_ACTION_YOLU = "/auth/action";

/**
 * `/auth/action` mi? Sondaki eğik çizgi KABUL EDİLİR.
 *
 * ⚠️ Eskiden `App.tsx` bunu `pathname === "/auth/action"` ile TAM EŞİTLİK
 * olarak ölçüyordu; `/auth/action/` hiçbir yere düşmüyor ve kullanıcı sessizce
 * ana akışta buluyordu kendini. Muafiyeti burada gevşetmek YETMEZDİ — kapı o
 * yolu muaf sayar, `App.tsx` yine render etmezdi (aynı sessiz düşüş, yeni
 * kılıkta). Bu yüzden İKİ TARAF DA bu yüklemi kullanır.
 */
export function authActionYoluMu(path: string): boolean {
  return /^\/auth\/action\/?$/.test(String(path || ""));
}

/**
 * Yasal sayfa slug'ları — `LegalPage` bunları `slug` prop'u olarak alır.
 * Sıra ÖNEMSİZ; eşleşme tam (alt yol kabul edilmez).
 */
export const YASAL_SLUGLAR = [
  "gizlilik-politikasi",
  "kullanim-kosullari",
  "cerez-politikasi",
  "topluluk-kurallari",
  "iletisim",
] as const;

export type YasalSlug = (typeof YASAL_SLUGLAR)[number];

/** `/{slug}` → slug, değilse `null`. Sondaki eğik çizgi kabul edilir. */
export function yasalSlugCoz(path: string): YasalSlug | null {
  const m = String(path || "").match(/^\/([a-z-]+)\/?$/);
  if (!m) return null;
  const slug = m[1] as YasalSlug;
  return (YASAL_SLUGLAR as readonly string[]).includes(slug) ? slug : null;
}

/**
 * `/card/{kod}` → kod, değilse `null`.
 *
 * Kod sınıfı `[A-Za-z0-9_-]+`: `kartDetayUrl.ts`in kart-kodu sınıfıyla aynı
 * aile. Çıplak `/card` BİLEREK eşleşmez — kodu olmayan bir kart şablonu yoktur,
 * dolayısıyla o yol gerçekten ölüdür ve kapıya düşmelidir.
 */
export function kartSablonKoduCoz(path: string): string | null {
  const m = String(path || "").match(/^\/card\/([A-Za-z0-9_-]+)\/?$/);
  return m ? m[1] : null;
}

/**
 * Bu yolu `App.tsx` çözücüden ÖNCE karşılıyor mu?
 *
 * Ölü rota kapısının muafiyet listesi budur — ve tek kaynağı `App.tsx`in
 * fiilen kullandığı çözücülerdir, elle tutulan bir kelime listesi değil.
 */
export function cozucuOncesiYolMu(path: string): boolean {
  const p = String(path || "");
  if (authActionYoluMu(p)) return true;
  if (kartSablonKoduCoz(p)) return true;
  if (yasalSlugCoz(p)) return true;
  return false;
}
